"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.splitFilter = exports.multiFilter = void 0;
/**
 * This is a filter function that filters into multiple positions, useful
 *  when traversing the data is expensive or is best expressed in one command
 */
function multiFilter(data, ...conditions) {
    const results = conditions.map((_) => []);
    for (let dataIndex = 0; dataIndex < data.length; dataIndex++) {
        const value = data[dataIndex];
        for (let conditionIndex = 0; conditionIndex < conditions.length; conditionIndex++) {
            if (conditions[conditionIndex](value, dataIndex, data)) {
                results[conditionIndex].push(value);
            }
        }
    }
    return results;
}
exports.multiFilter = multiFilter;
/**
 * This is a filter that filters to both sides of a conditional
 *  e.g. odd and even.
 *
 * [ filter is false, filter is true ]
 *
 * const [ odds, evens ] = splitFilter([1,2,3,4], (v) => v % 2)
 */
function splitFilter(data, filter) {
    const result = [[], []];
    for (let dataIndex = 0; dataIndex < data.length; dataIndex++) {
        const value = data[dataIndex];
        const resultIndex = filter(value, dataIndex, data) ? 0 : 1;
        result[resultIndex].push(value);
    }
    return result;
}
exports.splitFilter = splitFilter;
//# sourceMappingURL=enhancedFilters.js.map